module.exports = __webpack_public_path__ + "img/left-foot-off.8ceefb8e.png";